import React from 'react'
import PropTypes from 'prop-types'
import ReduxNavigator from 'components/Navigator/ReduxNavigator'
import { ADD_XMC, APPLY_FAST_FEATURES } from 'utils/constants'
import AddRemoveVehicleFeaturesContainer from '../../Summary/ChecPlusVehicleSummary/AddRemoveVehicleFeatures/AddRemoveVehicleFeaturesContainer'
import AddXMCContainer from '../AddXmc/AddXmcContainer'

const EcusNavigator = ({ location }) => {
  return (
    <ReduxNavigator
      render={({ id, ...renderProps }) => {
        let featureName
        let serialNumber
        if (id && id.includes(ADD_XMC)) {
          const [feature, serialNo] = id.split('-')
          serialNumber = serialNo || serialNumber
          featureName = feature
        }

        if (featureName === ADD_XMC && serialNumber) {
          return (
            <AddXMCContainer serialNumber={serialNumber} {...renderProps} />
          )
        }

        if (id === APPLY_FAST_FEATURES) {
          return (
            <AddRemoveVehicleFeaturesContainer
              {...renderProps}
              serialNumber={serialNumber}
              location={location}
              showFastFeatureFilters
            />
          )
        }

        return id ? (
          <AddRemoveVehicleFeaturesContainer
            {...renderProps}
            location={location}
          />
        ) : null
      }}
    />
  )
}

EcusNavigator.propTypes = {
  location: PropTypes.object.isRequired,
}

export default EcusNavigator
